import Vue from 'vue'
import config from 'src/conf'
import auth from 'src/auth'
import { getEpisodeImageURL } from 'src/utils'
const getEpisodeMetaData = (route) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get(config.url.episodes + '/' + route.params.episodeId, {
        params: {},
        headers: auth.getAuthHeader(),
      })
      .then((response) => {
        const data = response.body.data
        resolve({
          'og:title': data.title,
          'og:description': data.description,
          'og:image': getEpisodeImageURL(data.image, data.podcast_images.main),
        })
      })
      .catch((e) => {
        reject({})
      })
  })
}

const getPodcastMetaData = (route) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get(config.url.podcasts + '/' + route.params.slug, {
        params: {},
        headers: auth.getAuthHeader(),
      })
      .then((response) => {
        const data = response.body.data
        resolve({
          'og:title': data.title,
          'og:description': data.description,
          'og:image': getEpisodeImageURL(null, data.images.main),
        })
      })
      .catch((e) => {
        reject({})
      })
  })
}
const updateMetaData = (to) => {
  return new Promise((resolve, reject) => {
    let metaData = null
    if (to.name === 'Episode') {
      metaData = getEpisodeMetaData(to)
    }
    if (to.name === 'Podcast') {
      metaData = getPodcastMetaData(to)
    }
    if (metaData) {
      metaData
        .then((response) => {
          Object.keys(response).forEach((key) => {
            document.querySelector(`meta[property="${key}"]`).setAttribute('content', response[key])
          })
          resolve()
        })
        .catch(() => {
          reject()
        })
    }
    resolve()
  })
}

export default updateMetaData



// WEBPACK FOOTER //
// ./src/utils/meta-data-updator.js